module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJBAMAAAASvxsjAAAAFVBMVEWBh42Bh40AAACBh42Bh42Bh42Bh42vAC9HAAAABnRSTlMf3wC9Pz7DugWDAAAAL0lEQVQI12NgZlJiZmAwE1AQM2BgTAxMZGBQEEsTUGBQcksLUoCwgeKOiVA1EPUAs4gGnep1baUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_close_hover (2).png
// module id = OuVV
// module chunks = 9